import React from 'react';
import classNames from 'classnames';

export const WidgetInner = ({
  children,
  className = '',
  height,
  transparent = false,
  noBorder = false,
}) => {
  const style = height ? { height: `${height}px`, overflowY: 'auto' } : {};

  return (
    <div
      className={classNames('widget', className, {
        'widget-transparent': transparent,
        'widget-no-border': noBorder,
      })}
      style={style}
    >
      {children}
    </div>
  );
};
